import React from 'react';

const Watchlist = () => {
    return <div />;
};

export default Watchlist;